import * as React from 'react';

import { AuthProvider, ErrorProvider, I18nProvider, StoresProvider, ThemeProvider } from 'providers';

import { Router } from 'routing';
import { configure } from 'mobx';
import { inIframe } from "./utils";

configure({
  enforceActions: 'always',
  computedRequiresReaction: true,
  observableRequiresReaction: true,
  reactionRequiresObservable: true,
  disableErrorBoundaries: false,
});

function App() {
  if (inIframe()) return null;

  return (
    <ThemeProvider>
      <StoresProvider>
        <I18nProvider>
          <ErrorProvider>
            <AuthProvider>
              <Router />
            </AuthProvider>
          </ErrorProvider>
        </I18nProvider>
      </StoresProvider>
    </ThemeProvider>
  );
}

export default App;
